export default __webpack_public_path__ + "static/media/qrcode_android.a817f3a4.png";